import React, { useEffect } from 'react';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import HeadBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';
import Loading from '$/components/loading/Loading';
import { getIsCurrentUserSuperAdminState } from '$/store/profile/selectors';
import CloInfo from './CloInfo';
import { getCloDealById } from '$/store/cloDeal/actions';
import CloUpload from './CloUpload';
import { Routes, useMatch } from 'react-router-dom';

export interface ICLOProps {
  currentClo?: Bixby.Models.CloDeal;
  isLoading: boolean;
  dispatchGetClo: (id: string) => Promise<void>;
}

const CLO: React.FC<ICLOProps> = props => {
  const { currentClo, isLoading, dispatchGetClo } = props;
  const match = useMatch('/admin/clodeal/:cloId/*');

  useEffect(() => {
    if (match?.params.cloId && match.params.cloId !== currentClo?.id?.toLowerCase()) {
      dispatchGetClo(match.params.cloId);
    }
  }, [match, dispatchGetClo, currentClo?.id]);

  const baseUrl = `/admin/clodeal/${match?.params.cloId}`;
  const uploadUrl = `${baseUrl}/upload-clo`;

  if (isLoading) {
    return <Loading pageLevel />;
  } else {
    return currentClo &&
      !Bixby.Utils.isNullOrEmpty(currentClo) &&
      currentClo.id.toLowerCase() === match?.params?.cloId?.toLowerCase() ? (
      <React.Fragment>
        <HeadBlock title={currentClo?.name}>
          <HeadTab title="Profile" link={baseUrl} exact={true} />
          <HeadTab title="Upload" link={uploadUrl} exact={true} />
        </HeadBlock>
        <div className="clo_root_container">
          <Routes>
            <Route path={'/*'} element={<CloInfo />} />
            <Route path={'/upload-clo'} element={<CloUpload />} />
          </Routes>
        </div>
      </React.Fragment>
    ) : null;
  }
};

const mapStateToProps = (state: AppState) => {
  const { isSuperAdmin } = getIsCurrentUserSuperAdminState(state);
  return {
    isSuperAdmin,
    featureFlags: state.loginState.featureFlags,
    currentClo: state.cloDealState.currentCloDeal,
    isLoading: state.cloDealState.isLoading,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetClo: (cloId: string) => dispatch(getCloDealById(cloId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CLO);
